import { createRoute } from '@tanstack/react-router';
import { lazyPage } from '../common';
import { authedChromeRoute } from '../layouts';

const helpComp = lazyPage(() => import('./pages'), 'HelpHost');

// `/help` names no site, so the session guards leave whatever site is loaded in place and only
// fall back to the user's own team when nothing is - arriving from `/$siteId/test` must not move
// the user off that site, or out of test.
const helpRoute = createRoute({
  getParentRoute: () => authedChromeRoute,
  path: '/help',
  component: helpComp,
  staticData: { title: 'help.help' },
});

export { helpRoute };
